// Compare release versions with numeric components and optional prereleases.
// Returns >0 when a is newer. Stable releases sort above prereleases.
export function compareSemver(a, b) {
    const parse = (value) => {
        const match = String(value || "").trim().match(/^(\d+(?:\.\d+)*)(?:-([^+]+))?/);
        return {
            numbers: (match?.[1] ?? "").split(".").map((part) => Number.parseInt(part, 10) || 0),
            prerelease: match?.[2] ?? null,
            raw: String(value || ""),
        };
    };
    const left = parse(a);
    const right = parse(b);
    const length = Math.max(left.numbers.length, right.numbers.length);
    for (let i = 0; i < length; i += 1) {
        const delta = (left.numbers[i] || 0) - (right.numbers[i] || 0);
        if (delta !== 0) return delta;
    }
    if (left.prerelease === null && right.prerelease !== null) return 1;
    if (left.prerelease !== null && right.prerelease === null) return -1;
    if (left.prerelease !== right.prerelease) {
        const compareParts = (x, y) => {
            const xp = x.match(/\d+|[A-Za-z]+/g) ?? [];
            const yp = y.match(/\d+|[A-Za-z]+/g) ?? [];
            for (let i = 0; i < Math.max(xp.length, yp.length); i += 1) {
                const xn = /^\d+$/.test(xp[i] ?? "") ? Number(xp[i]) : null;
                const yn = /^\d+$/.test(yp[i] ?? "") ? Number(yp[i]) : null;
                if (xn !== null && yn !== null && xn !== yn) return xn - yn;
                if (xn !== null && yn === null) return -1;
                if (xn === null && yn !== null) return 1;
                if ((xp[i] ?? "") !== (yp[i] ?? "")) return (xp[i] ?? "") < (yp[i] ?? "") ? -1 : 1;
            }
            return 0;
        };
        const delta = compareParts(left.prerelease ?? "", right.prerelease ?? "");
        if (delta !== 0) return delta;
    }
    const normalize = (raw) => raw.split("+", 1)[0];
    if (normalize(left.raw) !== normalize(right.raw)) {
        return normalize(left.raw) < normalize(right.raw) ? -1 : 1;
    }
    return 0;
}

export const compareVersions = compareSemver;
